import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { SNACKS_CATALOG_CONFIG, SNACKS_CATALOG_TITLE_KEY, SnacksSelectedItems } from './InstancesCatalogSnacks-types'

const InstancesCatalogSnacksComponent = () => {
    const [selectedItems, setSelectedItems] = useState<SnacksSelectedItems>([])

    return (
        <Content title={SNACKS_CATALOG_TITLE_KEY}>
            <CustomList
                type={SNACKS_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={SNACKS_CATALOG_CONFIG.additionalData}
            />
        </Content>
    )
}

export const InstancesCatalogSnacks = checkAvailableModule('instancesCatalog/snacks')
    ? InstancesCatalogSnacksComponent
    : null
